import { render } from "./partners.vue?vue&type=template&id=77403b9b&scoped=true"
import script from "./partners.vue?vue&type=script&lang=js"
export * from "./partners.vue?vue&type=script&lang=js"

import "./partners.vue?vue&type=style&index=0&id=77403b9b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77403b9b"

export default script